import React, { useMemo } from 'react'
import { Control, Controller } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../../ChallengeAdmin'
import { InputAdornment } from '@material-ui/core'
import YumField from '../../../../../components/YumInput/YumInput'
import ErrorMessage from '../../../../../components/ErrorMessage/ErrorMessage'
import { ReactComponent as TotalAmountInactiveIcon } from '../../../../../assets/v3/icons/total-amount-inactive.svg'
import { getFieldName, getErrorMessage } from '../goalFormHelpers'

interface IndexTargetFieldProps {
  control: Control<FormData>
  fieldPrefix: string
  validationRules: {
    min?: number
    max?: number
    required?: boolean
  }
  unitText: string
  isDailyTarget?: boolean
}

/**
 * Index target input field for ALL activity type.
 * Allows users to set a target percentage.
 */
export default function IndexTargetField({
  control,
  fieldPrefix,
  validationRules,
  unitText,
  isDailyTarget = false,
}: IndexTargetFieldProps) {
  // Memoize InputProps to prevent input from losing focus on re-render
  const inputProps = useMemo(
    () => ({
      endAdornment: (
        <InputAdornment style={{ flexShrink: 0, pointerEvents: 'none' }} position="end" disableTypography>
          {unitText}
        </InputAdornment>
      ),
      // style: {
      //   background: 'white',
      // },
    }),
    [unitText],
  )

  // Use a more specific label when this target is daily.
  const labelText = isDailyTarget ? t`Daily target` : t`Target`

  return (
    <Controller
      name={getFieldName('indexTarget', fieldPrefix) as any}
      rules={validationRules}
      control={control}
      render={({ field: { ref, ...otherField }, fieldState: { error } }) => (
        <>
          <YumField
            label={labelText}
            type="number"
            inputProps={{ inputMode: 'numeric', 'aria-required': 'true' }}
            onWheel={(e: { target: { blur: () => any } }) => e.target.blur()}
            error={!!error}
            InputProps={inputProps}
            style={{
              marginBottom: 0,
            }}
            startIcon={TotalAmountInactiveIcon}
            {...otherField}
            value={otherField.value ?? ''}
          />
          {error && getErrorMessage(error) && <ErrorMessage>{getErrorMessage(error)}</ErrorMessage>}
        </>
      )}
    />
  )
}
